import {createSlice} from '@reduxjs/toolkit';
import {getAvailableActivityTypesForBuilding, getAvailableDeskAmenitiesForBuilding} from './actions';
import {TypologySliceState} from './types';

const initialState: TypologySliceState = {
  availableDeskAmenityData: {},
  availableActivityTypeData: {},
};

const slice = createSlice({
  name: 'typology',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAvailableDeskAmenitiesForBuilding.pending, (state, action) => {
        const {buildingId} = action.meta.arg;
        state.availableDeskAmenityData[buildingId] = {
          availableDeskAmenities: [],
          status: 'Loading',
        };
      })
      .addCase(getAvailableDeskAmenitiesForBuilding.fulfilled, (state, action) => {
        const {buildingId} = action.meta.arg;
        state.availableDeskAmenityData[buildingId] = {
          availableDeskAmenities: action.payload,
          status: 'Loaded',
        };
      })
      .addCase(getAvailableDeskAmenitiesForBuilding.rejected, (state, action) => {
        const {buildingId} = action.meta.arg;
        state.availableDeskAmenityData[buildingId] = {
          availableDeskAmenities: [],
          status: 'Failed',
        };
      })

      .addCase(getAvailableActivityTypesForBuilding.pending, (state, action) => {
        const {buildingId} = action.meta.arg;
        state.availableActivityTypeData[buildingId] = {
          availableActivityTypes: [],
          status: 'Loading',
        };
      })
      .addCase(getAvailableActivityTypesForBuilding.fulfilled, (state, action) => {
        const {buildingId} = action.meta.arg;
        state.availableActivityTypeData[buildingId] = {
          availableActivityTypes: action.payload,
          status: 'Loaded',
        };
      })
      .addCase(getAvailableActivityTypesForBuilding.rejected, (state, action) => {
        const {buildingId} = action.meta.arg;
        state.availableActivityTypeData[buildingId] = {
          availableActivityTypes: [],
          status: 'Failed',
        };
      });
  },
});

export const {reducer: typologyReducer} = slice;
